<template>
  <div >

    <div  >
      <v-progress-circular
              v-if="show_spinner"
              indeterminate
              color="grey"
              :size="100"
              :width="5"
      ></v-progress-circular>
    </div>


    <v-card class="form">
      <v-card-title>
        Contact Us
      </v-card-title>

      <v-card-text>
        <v-form  ref="contactForm"  id="contactUsForm">
          <v-text-field
                  label="Name*"
                  v-model="form.name"
                  :rules="[x=>isRequired(x, 'Name')]"
                  name="name"
          ></v-text-field>


          <v-text-field
                  label="Email*"
                  name="email"
                  v-model="form.email"

                  :rules="[x=>isRequired(x, 'Email')]"
          ></v-text-field>

          <v-text-field
                  label="Company"
                  name="company"
                  v-model="form.company"
          ></v-text-field>


          <v-textarea
                  label="How Can We Help?"
                  v-model="form.comment"
                  name="message"
                  outline
          ></v-textarea>


        </v-form>

      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color='primary' :disabled="show_spinner" @click="submit">Submit</v-btn>
      </v-card-actions>
    </v-card>




  </div>
</template>


<style scoped lang="scss" >
  @import '../assets/styles/variables/Variables';
  


  .form{
    width: 400px;
  }




</style>







<script>
   import validate from '@/mixins/validation'

   import {init as emailjs_init, sendForm} from 'emailjs-com';


   let form0 = {
     name: '',
      company: '',
     email: '',
     phone: '',
     comment: ''
  };

export default {
  name: 'contact',

   mixins: [validate],
   data: () => ({

      form: Object.assign({}, form0),
      show_spinner: false,

   }),



   props:{


   },

   methods: {
     submit(){
        let this_app = this; //needed so that this becomes a closure variable

        console.log('i ran')

        this.show_spinner = true;
        if (this.$refs.contactForm.validate()){
           sendForm('espy_info', 'website_info_form', '#contactUsForm')
              .then(function(response) {
                 console.log('SUCCESS!', response.status, response.text);
                 this_app.$router.push({
                    path: '/thankyou'
                 })
              }, function(error) {
                 window.alert('Opps we had an error submitting...Would you mind trying again.');
                 this.show_spinner = false;
                 console.log('FAILED...', error);
              });
        }
        else{
           this.show_spinner = false;
           return
        }
     },

      // submit_form(){

      //    document.getElementById('spinnerid').style =  'display: flex;';

      //    sendForm('espy_info', 'website_info_form', '#contactUsForm')
      //       .then(function(response) {
      //          console.log('SUCCESS!', response.status, response.text);
      //          this.$router.push({
      //             path: '/thankyou'
      //          })
      //       }, function(error) {
      //          window.alert('Opps we had an error submitting...Would you mind trying again.');
      //          document.getElementById('spinner').style =  'display: none;';
      //          console.log('FAILED...', error);
      //       });
      // }

   },

   mounted(){
      emailjs_init("user_QAwV7nRjZlxo3phyl3mIp");
   }
};
</script>















